import { render } from "./Amplified.vue?vue&type=template&id=36b77b79&scoped=true"
import script from "./Amplified.vue?vue&type=script&lang=js"
export * from "./Amplified.vue?vue&type=script&lang=js"

import "./Amplified.vue?vue&type=style&index=0&id=36b77b79&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b77b79"]])

export default __exports__